import FeatureIntroductionListPage from "./pages/FeatureIntroductionListPage.vue";
import FeatureIntroductionCreatePage from "./pages/FeatureIntroductionCreatePage.vue";

export const featureIntroductionRoutes = (prefix = "feature-introduction") => [
  {
    name: "FeatureIntroductionListPage",
    path: prefix,
    component: FeatureIntroductionListPage
  },
  {
    name: "FeatureIntroductionCreatePage",
    path: `${prefix}/create`,
    component: FeatureIntroductionCreatePage
  }
];



// WEBPACK FOOTER //
// ./src/features/communications/modules/featureIntroduction/routes.js